module.exports = __webpack_public_path__ + "static/media/11.final.c0de8c6f.mp4";